function Home() {
  return (
    <div>Restricted</div>
  );
}

export default Home;


